import { ALLOWED_SERVICES_SLUG, type TServiciosSlug } from '~~/constants';
import type { UserPreferences } from '~~/stores/userconfig';

export const determineRedirect = (
  servicioSlug: string | undefined,
  fullPath: string,
  isMitren: boolean,
  _cookieServicio: string | undefined
): string | null => {
  if (
    servicioSlug &&
    !(ALLOWED_SERVICES_SLUG as unknown as string[]).includes(servicioSlug)
  ) {
    return isMitren ? '/' : '/biotren';
  }

  if (_cookieServicio && fullPath === '/') {
    return `/${_cookieServicio}`;
  }

  return null;
};

export default defineNuxtRouteMiddleware(async (to) => {
  const isMitren = useRuntimeConfig().public.mitren;
  const cookie = useCookie<UserPreferences>('mb_user');
  const servicioSlug = to.params.servicio as TServiciosSlug;

  const redirect = determineRedirect(
    servicioSlug,
    to.fullPath,
    isMitren,
    cookie.value?.servicio
  );

  if (redirect) {
    return navigateTo(redirect);
  }
});
